
import { Record, Union } from "../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { record_type, option_type, list_type, class_type, string_type, union_type } from "../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { InspectionTemplateId_$reflection, InspectionResultId_$reflection } from "./Shared.js";

export class InspectionResultStatus extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Successful", "Failed"];
    }
}

export function InspectionResultStatus_$reflection() {
    return union_type("Shared.InspectionResult.InspectionResultStatus", [], InspectionResultStatus, () => [[], []]);
}

export class InspectionResult extends Record {
    constructor(Id, ToolId, InspectionTemplateId, InspectionTemplateName, InspectionDate, Result, ResultStatus, Comment$, DocumentIds, ReminderId, CreatedAt, UpdatedAt) {
        super();
        this.Id = Id;
        this.ToolId = ToolId;
        this.InspectionTemplateId = InspectionTemplateId;
        this.InspectionTemplateName = InspectionTemplateName;
        this.InspectionDate = InspectionDate;
        this.Result = Result;
        this.ResultStatus = ResultStatus;
        this.Comment = Comment$;
        this.DocumentIds = DocumentIds;
        this.ReminderId = ReminderId;
        this.CreatedAt = CreatedAt;
        this.UpdatedAt = UpdatedAt;
    }
}

export function InspectionResult_$reflection() {
    return record_type("Shared.InspectionResult.InspectionResult", [], InspectionResult, () => [["Id", InspectionResultId_$reflection()], ["ToolId", string_type], ["InspectionTemplateId", InspectionTemplateId_$reflection()], ["InspectionTemplateName", string_type], ["InspectionDate", class_type("System.DateTime")], ["Result", string_type], ["ResultStatus", InspectionResultStatus_$reflection()], ["Comment", string_type], ["DocumentIds", list_type(string_type)], ["ReminderId", option_type(string_type)], ["CreatedAt", class_type("System.DateTime")], ["UpdatedAt", class_type("System.DateTime")]]);
}

export class DTO_WriteInspectionResultDto extends Record {
    constructor(InspectionTemplateId, InspectionDate, Result, ResultStatus, Comment$, DocumentIds, ReminderId) {
        super();
        this.InspectionTemplateId = InspectionTemplateId;
        this.InspectionDate = InspectionDate;
        this.Result = Result;
        this.ResultStatus = ResultStatus;
        this.Comment = Comment$;
        this.DocumentIds = DocumentIds;
        this.ReminderId = ReminderId;
    }
}

export function DTO_WriteInspectionResultDto_$reflection() {
    return record_type("Shared.InspectionResult.DTO.WriteInspectionResultDto", [], DTO_WriteInspectionResultDto, () => [["InspectionTemplateId", class_type("System.Guid")], ["InspectionDate", class_type("System.DateTime")], ["Result", string_type], ["ResultStatus", InspectionResultStatus_$reflection()], ["Comment", string_type], ["DocumentIds", list_type(string_type)], ["ReminderId", option_type(string_type)]]);
}

export class DTO_UpdateInspectionResultDto extends Record {
    constructor(InspectionDate, Result, ResultStatus, Comment$, DocumentIds) {
        super();
        this.InspectionDate = InspectionDate;
        this.Result = Result;
        this.ResultStatus = ResultStatus;
        this.Comment = Comment$;
        this.DocumentIds = DocumentIds;
    }
}

export function DTO_UpdateInspectionResultDto_$reflection() {
    return record_type("Shared.InspectionResult.DTO.UpdateInspectionResultDto", [], DTO_UpdateInspectionResultDto, () => [["InspectionDate", class_type("System.DateTime")], ["Result", string_type], ["ResultStatus", InspectionResultStatus_$reflection()], ["Comment", string_type], ["DocumentIds", list_type(string_type)]]);
}

export class DTO_InspectionResultDetailDto extends Record {
    constructor(Id, InspectionTemplateId, InspectionTemplateName, InspectionDate, Result, ResultStatus, Comment$, DocumentIds, ReminderId, ReminderTitle) {
        super();
        this.Id = Id;
        this.InspectionTemplateId = InspectionTemplateId;
        this.InspectionTemplateName = InspectionTemplateName;
        this.InspectionDate = InspectionDate;
        this.Result = Result;
        this.ResultStatus = ResultStatus;
        this.Comment = Comment$;
        this.DocumentIds = DocumentIds;
        this.ReminderId = ReminderId;
        this.ReminderTitle = ReminderTitle;
    }
}

export function DTO_InspectionResultDetailDto_$reflection() {
    return record_type("Shared.InspectionResult.DTO.InspectionResultDetailDto", [], DTO_InspectionResultDetailDto, () => [["Id", class_type("System.Guid")], ["InspectionTemplateId", class_type("System.Guid")], ["InspectionTemplateName", string_type], ["InspectionDate", class_type("System.DateTime")], ["Result", string_type], ["ResultStatus", InspectionResultStatus_$reflection()], ["Comment", string_type], ["DocumentIds", list_type(string_type)], ["ReminderId", option_type(string_type)], ["ReminderTitle", option_type(string_type)]]);
}

